module.exports = __webpack_public_path__ + "img/chris_g_38.beb15532.jpg";